import React from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

const BTextArea = ({ label, controlId, rows, serverError, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <>
            <Form.Group controlId={controlId}>
                {label && <Form.Label>{label}</Form.Label>}
                <Form.Control
                    {...props}
                    {...field}
                    as="textarea"
                    rows={rows}
                    isInvalid={meta.error && meta.touched}
                    isValid={!meta.error && meta.touched}
                />
                {meta.error && meta.touched ? (
                    <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                ) : null}
                {serverError ? <span className="text-danger">{serverError}</span> : null}
            </Form.Group>
        </>
    );
};

BTextArea.defaultProps = {
    rows: 3,
    serverError: null
};

BTextArea.propTypes = {
    label: PropTypes.string,
    controlId: PropTypes.string,
    rows: PropTypes.number
};

export default BTextArea;
